(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('reportsService', reportsService);

    reportsService.$inject = ['$http', '$filter', 'modelTransformer', 'messaging', 'events'];

    function reportsService($http, $filter, modelTransformer, messaging, events) {
        var baseUrl = '/api/reports/';
        var projects = [];
        var dId = 0;
        var service = {
            init: init
        };

        function findAndReplace(string, target, replacement) {

            var i = 0, length = string.length;

            for (i; i < length; i++) {

                string = string.replace(target, replacement);

            }

            return string;

        }

        messaging.subscribe(events.message._GET_SUMMARY_REPORT_LIST_,getSummaryReport);
        messaging.subscribe(events.message._GET_FIRE_HOUR_DATA_LIST_, getFireHoursData);
        messaging.subscribe(events.message._GET_FIRE_SAFETY_DATA_LIST_, getFireSafetyData);
        messaging.subscribe(events.message._GET_COMMUNITY_DATA_LIST_, getCommunityHoursData);
        messaging.subscribe(events.message._GET_STUDENT_FSHOURS_LIST_, getStudentFSHoursData);
        messaging.subscribe(events.message._GET_STUDENT_FIREHOURS_LIST_, getStudentFireHoursData);
        messaging.subscribe(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_, getStudentCommunityHoursData);
        messaging.subscribe(events.message._GET_FS1800_16_LIST_, getFS1800_16Data);
        messaging.subscribe(events.message._GET_YOUTHANDVOLUNTEER_LIST_, getYouthAndVolunteerData);
        messaging.subscribe(events.message._GET_PLC_TOTAL_HOURS_LIST_, getPLCTotalHoursData);
        return service;
        function init() {
        }

        function getSummaryReport(data) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_); 

            $http.post(baseUrl + 'GetSummaryReport/', data)
                .then(getSummaryReportSuccessHandler, getSummaryReportErrorHandler);

        }
        function getFireHoursData(calendarYear) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetFireHoursData/' + calendarYear;

            $http.get(baseUrl + url)
                .then(getFireHoursSuccessHandler, getFireHoursErrorHandler);

        }
        function getFireSafetyData(calendarYear) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetFireSafetyData/' + calendarYear;

            $http.get(baseUrl + url)
                .then(getFireSafetySuccessHandler, getFireSafetyErrorHandler);

        }
        function getCommunityHoursData(calendarYear, isPLC) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetCommunityData/' + calendarYear + '/' + isPLC;

            $http.get(baseUrl + url)
                .then(getCommunityHoursSuccessHandler, getCommunityHoursErrorHandler);

        }

        function getStudentFireHoursData(calendarYear, startDate, endDate) {
            if (startDate !== null && startDate !== undefined && startDate.length && endDate !== null && endDate !== undefined) { startDate = findAndReplace(startDate, '/', '-'); calendarYear = 0; } else { startDate = '01-01-0001'; }
            if (endDate !== null && startDate !== undefined && startDate.length && endDate !== undefined && endDate.length) { endDate = findAndReplace(endDate, '/', '-'); } else { endDate = '01-01-0001'; }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetStudentFireHours/' + calendarYear + "/" + startDate + '/' + endDate; 
            $http.get(baseUrl + url)
                .then(getStudentFireHoursSuccessHandler, getStudentFireHoursErrorHandler);

        }
        function getStudentFSHoursData(calendarYear, startDate, endDate) {
            if (startDate !== null && startDate !== undefined && startDate.length && endDate !== null && endDate !== undefined) { startDate = findAndReplace(startDate, '/', '-'); calendarYear = 0; } else { startDate = '01-01-0001'; }
            if (endDate !== null && startDate !== undefined && startDate.length && endDate !== undefined && endDate.length) { endDate = findAndReplace(endDate, '/', '-'); } else { endDate = '01-01-0001'; }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetStudentFSHours/' + calendarYear + "/" + startDate + '/' + endDate;

            $http.get(baseUrl + url)
                .then(getStudentFSHoursSuccessHandler, getStudentFSHoursErrorHandler);

        }
        function getStudentCommunityHoursData(calendarYear, startDate, endDate) {
            if (startDate !== null && startDate !== undefined && startDate.length && endDate !== null && endDate !== undefined) { startDate = findAndReplace(startDate, '/', '-'); calendarYear = 0; } else { startDate = '01-01-0001';}
            if (endDate !== null && startDate !== undefined && startDate.length && endDate !== undefined && endDate.length) { endDate = findAndReplace(endDate, '/', '-'); } else { endDate = '01-01-0001'; }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetStudentCommunityHours/' + calendarYear + "/" + startDate + '/' + endDate;

            $http.get(baseUrl + url)
                .then(getStudentCommunityHoursSuccessHandler, getStudentCommunityHoursErrorHandler);

        }
        function getFS1800_16Data(calendarYear, startDate, endDate) {
            if (startDate !== null && startDate !== undefined && startDate.length && endDate !== null && endDate !== undefined) { startDate = findAndReplace(startDate, '/', '-'); calendarYear = 0; } else { startDate = '01-01-0001'; }
            if (endDate !== null && startDate !== undefined && startDate.length && endDate !== undefined && endDate.length) { endDate = findAndReplace(endDate, '/', '-'); } else { endDate = '01-01-0001'; }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetFS1800_16Report/' + calendarYear + "/" + startDate + '/' + endDate; 
            $http.get(baseUrl + url)
                .then(getFS1800_16ReportSuccessHandler, getFS1800_16ReportErrorHandler);

        }
        function getPLCTotalHoursData(calendarYear, startDate, endDate) {
            if (startDate !== null && startDate !== undefined && startDate.length && endDate !== null && endDate !== undefined) { startDate = findAndReplace(startDate, '/', '-'); calendarYear = 0; } else { startDate = '01-01-0001'; }
            if (endDate !== null && startDate !== undefined && startDate.length && endDate !== undefined && endDate.length) { endDate = findAndReplace(endDate, '/', '-'); } else { endDate = '01-01-0001'; }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetPLCTotalHoursReport/' + calendarYear + "/" + startDate + '/' + endDate;

            $http.get(baseUrl + url)
                .then(getPLCTotalHoursDataSuccessHandler, getPLCTotalHoursDataErrorHandler);

        }
        function getYouthAndVolunteerData(calendarYear, startDate, endDate) {
            if (startDate !== null && startDate !== undefined && startDate.length && endDate !== null && endDate !== undefined) { startDate = findAndReplace(startDate, '/', '-'); calendarYear = 0; } else { startDate = '01-01-0001'; }
            if (endDate !== null && startDate !== undefined && startDate.length && endDate !== undefined && endDate.length) { endDate = findAndReplace(endDate, '/', '-'); } else { endDate = '01-01-0001'; }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetYouthAndVolunteerReport/' + calendarYear + "/" + startDate + '/' + endDate;

            $http.get(baseUrl + url)
                .then(getYouthAndVolunteerDataSuccessHandler, getYouthAndVolunteerDataErrorHandler);

        }
        function getYouthAndVolunteerDataSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_YOUTHANDVOLUNTEER_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getFireHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getYouthAndVolunteerDataErrorHandler(results) {
            messaging.publish(events.message._GET_YOUTHANDVOLUNTEER_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Youth and Volunteer Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getPLCTotalHoursDataSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_PLC_TOTAL_HOURS_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getPLCTotalHoursDataErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getPLCTotalHoursDataErrorHandler(results) {
            messaging.publish(events.message._GET_PLC_TOTAL_HOURS_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get PLC Total Hours Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getSummaryReportSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_SUMMARY_REPORT_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getSummaryReportErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getSummaryReportErrorHandler(results) {
            messaging.publish(events.message._GET_SUMMARY_REPORT_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Summary Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getStudentFSHoursSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_STUDENT_FSHOURS_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getStudentFSHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getStudentFSHoursErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_FSHOURS_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Student Forest Safety Hours Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getStudentFireHoursSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_STUDENT_FIREHOURS_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getStudentFireHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getStudentFireHoursErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_FIREHOURS_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Student Fire Hours Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getStudentCommunityHoursSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getStudentCommunityHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getStudentCommunityHoursErrorHandler(results) {
            messaging.publish(events.message._GET_STUDENT_COMMUNITYHOURS_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Student Rural Development Hours Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getFireHoursSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_FIRE_HOUR_DATA_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getFireHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getFireSafetySuccessHandler(results) {
            if (results.data) {
                var fh = results.data;
                messaging.publish(events.message._GET_FIRE_SAFETY_DATA_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getFireSafetyErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getCommunityHoursSuccessHandler(results) {
            if (results.data) {
                messaging.publish(events.message._GET_COMMUNITY_DATA_LIST_COMPLETE_, [results.data]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getCommunityHoursErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }

        function getFS1800_16ReportSuccessHandler(results) {
            if (results.data && results.data.length) {
                var fh = results.data;
                messaging.publish(events.message._GET_FS1800_16_LIST_COMPLETE_, [fh]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getFS1800_16ReportErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getFS1800_16ReportErrorHandler(results) {
            messaging.publish(events.message._GET_FS1800_16_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get FS 1800-16 Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function getFireHoursErrorHandler(results) {
            messaging.publish(events.message._GET_FIRE_HOUR_DATA_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Fire Hour Data from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getFireSafetyErrorHandler(results) {
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            messaging.publish(events.message._GET_FIRE_SAFETY_DATA_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Forest Safety Data List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getCommunityHoursErrorHandler(results) {
            messaging.publish(events.message._GET_COMMUNITY_DATA_LIST_COMPLETE_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Rural Development Hours Data List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
    }
})();